import React from 'react';

import { Text, TypeTextProps } from '@thefarmersfront/kitchen';

import { Bullet } from '..';

import styles from './InfoText.module.scss';

const InfoText = ({
  children,
  size = 'small',
  bulletColor = '#BCC4CC',
}: {
  children: React.ReactNode;
  size?: TypeTextProps['size'];
  bulletColor?: string;
}) => {
  return (
    <div className={styles['info-text']}>
      <Bullet className={styles['bullet']} fill={bulletColor} />
      <Text className={styles['text']} size={size} color="secondary" element="span">
        {children}
      </Text>
    </div>
  );
};

export default InfoText;
